let config = {
  inputLabel: 'body',
  key: 'description',
  inputType: 'textblock',
};

export default config;
